import Vue, { Component } from 'vue';
import { Component as ComponentDecorator } from 'vue-property-decorator';
import Header8 from './Header.8.vue';

@ComponentDecorator({
  props: {
    colorClass: String,
    version: Number,
    background: String,
    foreground: String,
    logo: Object,
    items: Array,
    hideOnInitial: Boolean,
  },
})

export default class CubeHeader extends Vue {
  public SelectedHeader(): Component {
    switch ((this as any).version) {
      case 8:
      default: return Header8;
    }
  }
}
